export const FIND_MODULE_SUCCESS = 'FIND_MODULE_SUCCESS';

export const findModuleSuccess = module => ({
    type: FIND_MODULE_SUCCESS,
    payload: { module },
});
